export var EFilterType;
(function (EFilterType) {
    EFilterType["number"] = "number";
    EFilterType["text"] = "text";
    EFilterType["boolean"] = "boolean";
    EFilterType["freeText"] = "freeText";
    EFilterType["treeSelect"] = "treeSelect";
    EFilterType["subMenu"] = "subMenu";
})(EFilterType || (EFilterType = {}));
export var EFilterLayout;
(function (EFilterLayout) {
    EFilterLayout["vertical"] = "vertical";
    EFilterLayout["horizontal"] = "horizontal";
})(EFilterLayout || (EFilterLayout = {}));
